function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstablishmentCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.46,
    height: 26.722,
    viewBox: "0 0 29.46 26.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7ti3a8vj0a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 163",
    style: {
      fill: "#ec660b"
    },
    d: "M0 0h29.46v26.722H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 14"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 293",
    style: {
      clipPath: "url(#7ti3a8vj0a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 545",
    d: "M26.816 10.772v13.27c.417 0 .814-.009 1.21 0a1.356 1.356 0 0 1 1.431 1.335 1.32 1.32 0 0 1-1.418 1.333c-1.763.016-3.527.007-5.291.007H1.929c-.211 0-.422 0-.633-.01a1.318 1.318 0 0 1-1.29-1.281 1.336 1.336 0 0 1 1.27-1.372c.436-.031.875-.006 1.352-.006v-13.27c-.205.126-.373.237-.548.336A1.34 1.34 0 0 1 .214 10.7a1.306 1.306 0 0 1 .4-1.82c.546-.389 1.119-.738 1.681-1.1C6.081 5.313 9.877 2.858 13.654.372a1.75 1.75 0 0 1 2.163.006c4.211 2.767 8.44 5.5 12.663 8.253.112.073.228.143.336.222a1.331 1.331 0 0 1 .426 1.861 1.351 1.351 0 0 1-1.872.394c-.162-.092-.319-.193-.553-.335M18.75 24.025v-7.342a1.364 1.364 0 0 0-1.553-1.553q-2.441-.018-4.882 0c-1.127.006-1.6.491-1.6 1.623v7.273z",
    style: {
      fill: "#ec660b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstablishmentCard);
export default __webpack_public_path__ + "static/media/establishment-card.688d14485185b5a302211866359afe6b.svg";
export { ForwardRef as ReactComponent };